import { render, staticRenderFns } from "./RecshareApprList.vue?vue&type=template&id=13a770eb&scoped=true"
import script from "./RecshareApprList.vue?vue&type=script&lang=js"
export * from "./RecshareApprList.vue?vue&type=script&lang=js"
import style0 from "./RecshareApprList.vue?vue&type=style&index=0&id=13a770eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a770eb",
  null
  
)

export default component.exports